import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { DEFAULT_CENTER } from "@/lib/categories";
import { t } from "@/lib/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useGeolocation = () => {
  const [status, setStatus] = useState("loading");
  const [position, setPosition] = useState(DEFAULT_CENTER);
  const [place, setPlace] = useState("Ciudad de México, CDMX");

  const resolvePlace = async ([lat, lng]) => {
    try {
      const { data } = await axios.get(`${API}/reverse-geocode`, { params: { lat, lng } });
      setPlace(data.label);
    } catch {
      setPlace(`${lat.toFixed(4)}, ${lng.toFixed(4)}`);
    }
  };

  const request = useCallback((notify = false) => {
    if (!navigator.geolocation) {
      setStatus("unavailable");
      return;
    }
    setStatus("loading");
    navigator.geolocation.getCurrentPosition(
      (p) => {
        const pos = [p.coords.latitude, p.coords.longitude];
        setPosition(pos);
        setStatus("granted");
        resolvePlace(pos);
        if (notify) toast.success(t("geo.updated"));
      },
      () => {
        setStatus("denied");
        setPosition(DEFAULT_CENTER);
        setPlace("Ciudad de México, CDMX");
        if (notify) toast.error(t("geo.error"));
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  }, []);

  useEffect(() => {
    request(false);
  }, [request]);

  return { status, position, place, request, isReal: status === "granted" };
};
